import React from "react";
import BannerImage from "./BannerImage";
import LeftImgRightText from "./LeftImgRightText";
import RightImgLeftText from "./RightImgLeftText";
import "../App.css";

const TransportGuard = () => {
  document.title = "TransportGuard";

  return (
    <div className="ui">
      <BannerImage
        title={"Transport Assistant"}
        image={require("../assets/img/tg/gg1.jpg")}
      />

      <div className="marginTopBtm">
        <LeftImgRightText
          image={require("../assets/img/tg/ss1.png")}
          text={"TransportGuard"}
          obj={{
            title: "Map View Bus Stops",
            desc: "Overview of nearby bus stops",
            dl: "Move around in the map to check for bus stops around your pin.",
          }}
          links={{
            ios: "https://apps.apple.com/app/id1593829504",
            android:
              "https://play.google.com/store/apps/details?id=io.devjo.transport",
          }}
        />
      </div>

      <div className="altColor marginTopBtm">
        <RightImgLeftText
          image={require("../assets/img/tg/ss2.png")}
          text={"TransportGuard"}
          obj={{
            title: "Accurate Bus Arrival",
            desc: "Descriptive and clear bus arrival timing",
            dl: "Check for bus arrival timing for the bus you are waiting for. View the icons for bus type and wheelchair accessibility.",
          }}
          links={{
            ios: "https://apps.apple.com/app/id1593829504",
            android:
              "https://play.google.com/store/apps/details?id=io.devjo.transport",
          }}
        />
      </div>

      <div className="marginTopBtm">
        <LeftImgRightText
          image={require("../assets/img/tg/ss3.png")}
          text={"TransportGuard"}
          obj={{
            title: "All in One",
            desc: "Get your bus service details",
            dl: "Whatever bus information you need, you can find their detailed information in this app.",
          }}
          links={{
            ios: "https://apps.apple.com/app/id1593829504",
            android:
              "https://play.google.com/store/apps/details?id=io.devjo.transport",
          }}
        />
      </div>

      <div className="altColor marginTopBtm">
        <RightImgLeftText
          image={require("../assets/img/tg/ss4.png")}
          text={"TransportGuard"}
          obj={{
            title: "Search for specific",
            desc: "Verify and double check",
            dl: "Save time and check for information that you need and filter out unnecessary details.",
          }}
          links={{
            ios: "https://apps.apple.com/app/id1593829504",
            android:
              "https://play.google.com/store/apps/details?id=io.devjo.transport",
          }}
        />
      </div>

      <div className="marginTopBtm">
        <LeftImgRightText
          image={require("../assets/img/tg/ss5.png")}
          text={"TransportGuard"}
          obj={{
            title: "More Information",
            desc: "Full bus service description",
            dl: "Be it first bus or last bus at each specific bus stop, we are here to provide you the most accurate information.",
          }}
          links={{
            ios: "https://apps.apple.com/app/id1593829504",
            android:
              "https://play.google.com/store/apps/details?id=io.devjo.transport",
          }}
        />
      </div>
    </div>
  );
};

export default TransportGuard;
